<header class="header">
    @if (!isReportsUrl()) {
        <app-organization-switcher></app-organization-switcher>
    }
    <div class="userInteraction">
        @if (user()) {
            <div class="search">
                <app-search-main-entities></app-search-main-entities>
            </div>
            <div class="panels">
                <app-user-apps-panel></app-user-apps-panel>
                <app-notifications-panel></app-notifications-panel>
                <app-user-panel [user]="user()" [showSubheading]="false"></app-user-panel>
            </div>
        }
    </div>
</header>
